<template>
    <button class="button__default" type="button">
        <slot></slot>
    </button>
</template>

<script>    
    export default {}
</script>

<style scoped lang="scss">
    @import '../../../scss/elements/buttons.scss';
</style>